export const convertToFloatFormat = (value) => (value ? parseFloat(value.replace(',', '.')) : value);

export const convertToString = (value) => (value ? value.toString().replace('.', ',') : value);
